export default "__VITE_ASSET__Blb_Iujq__"